module.exports = __webpack_public_path__ + "static/media/Onboarding3.99317e3c.png";